import angular from 'angular';
import uiRouter from 'angular-ui-router';
import playerComponent from './player.component';

let playerModule = angular.module('player', [
  uiRouter,
  'navigation'
])

.config(($stateProvider, $urlRouterProvider) => {
  'ngInject';

  $stateProvider
    .state('player', {
      url: '/player',
      params: {
        url: undefined,
        label: undefined,
        externalId: undefined,
        previousPage: undefined,
        index: undefined
      },
      template: '<player></player>'
    });
})

.component('player', playerComponent);

export default playerModule;



// WEBPACK FOOTER //
// ./client/app/components/player/player.js